import { useState } from 'react'
import { useBreakpoint } from '@ocean/hooks'
import { common, modals } from '@ocean/ui'
import { ListItemLayout, ListItemSegment } from 'layouts/lists'
import { ListItemTitle, ListItemInfo } from 'components/lists/common'
import { ListItemCommonProps } from 'components/lists/types'
import { Root, IconFlag, IconWrapper } from './NotificationsListItem.styled'

const { Typography } = common
const { Popup } = modals

type NotificationDetailsProps = {
  description?: string
}

const NotificationDetails: React.FC<NotificationDetailsProps> = ({ description }) => (
  <Typography variant='p'>{description}</Typography>
)

const NotificationsListItem: React.FC<ListItemCommonProps> = ({
  onClick,
  header,
  title,
  footer,
}) => {
  const isDesktop = useBreakpoint('md')
  const [isModalOpen, setModalVisibility] = useState(false)

  const Icon = () => (
    <IconWrapper>
      <IconFlag icon='flag' data-test='NotificationsListItemIcon' />
    </IconWrapper>
  )

  function toggleModal() {
    setModalVisibility(!isModalOpen)
  }

  function handleClick() {
    toggleModal()
    onClick && onClick()
  }

  return (
    <Root onClick={handleClick} data-test='NotificationsListItem'>
      <ListItemLayout>
        <ListItemSegment segmentId='header'>
          <ListItemInfo info={header} dataTest='NotificationsListItemHeader' />
        </ListItemSegment>
        <ListItemSegment segmentId='content'>
          <ListItemTitle title={title} dataTest='NotificationsListItemContent' />
        </ListItemSegment>
        <ListItemSegment segmentId='footer'>
          <ListItemInfo info={footer} dataTest='NotificationsListItemFooter' />
        </ListItemSegment>
        <ListItemSegment segmentId='sidebar'>
          <Icon data-test='NotificationsListItemIcon' />
        </ListItemSegment>
      </ListItemLayout>
      <Popup
        isOpen={isModalOpen}
        onClose={toggleModal}
        title={title}
        width={isDesktop ? '660px' : undefined}
      >
        <NotificationDetails description={title} />
      </Popup>
    </Root>
  )
}

export default NotificationsListItem
